<template>
	<div class="incenters TableBox" v-if="tableDataDetail.length">
		<div class="TableWidth" style="overflow-x: scroll;">
			<Commontable :rowhe="false" colnum=7 :loadingTable="loadingTable" :tableData="tableDataDetail"
				:headerData="headerData" height="100%"></Commontable>
		</div>
	</div>
</template>

<script>
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import {
		wmsDespatchDetail,
		wmsDespatchDetailUnique

	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,

		},
		props: ['tableDataUnique', 'tableDataDetail'],
		data: function() {
			return {
				loadingTable: false,
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 120
					},
					{
						prop: 'InvCode',
						label: '产品编码',
						columnwidth: 'auto'
					},
					{
						prop: 'InvAddCode',
						label: '产品代码',
						columnwidth: 'auto'
					},
					{
						prop: 'InvName',
						label: '产品名称',
						columnwidth: 'auto'
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 'auto'
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 'auto'
					},
				],
				tableData: [],
				onchage: 0,
				tableflag: true,
				tableflags: false,
			}
		}
	}
</script>

<style lang="less" scoped>
	.ativte {
		border: 1px solid red;
		color: #e71d43;
		background-color: #fce8ec;
		transition: 0.2s linear;
	}

	.incenters {
		height: 100%;
		font-family: "微软雅黑";
		background-color: #fff;
		width: 980px;
		margin-top: 10px;
		padding-bottom: 10px;
		padding-top: 2px;

		div {
			margin-left: 8px;
			margin-right: 8px;
			margin-top: 5px;
			margin-bottom: 5px;
			// width: 100%;
		}
	}

	.topstate {
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid #e6e6e6;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
		user-select: none;
	}
</style>